export default __webpack_public_path__ + "static/media/icons8-program-100.fdde0aa6.svg";